var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 14.0007L7.99996 1.33398L15.3333 14.0007H0.666626ZM7.99996 12.0007C8.18885 12.0007 8.34729 11.9367 8.47529 11.8087C8.60329 11.6807 8.66707 11.5224 8.66663 11.334C8.66618 11.1455 8.60218 10.9873 8.47463 10.8593C8.34707 10.7313 8.18885 10.6673 7.99996 10.6673C7.81107 10.6673 7.65285 10.7313 7.52529 10.8593C7.39774 10.9873 7.33374 11.1455 7.33329 11.334C7.33285 11.5224 7.39685 11.6809 7.52529 11.8093C7.65374 11.9378 7.81196 12.0015 7.99996 12.0007ZM7.33329 10.0007H8.66663V6.66732H7.33329V10.0007Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.bb58ce94f5d7f13ec726b4aa4d8c1e13.svg";
export { ForwardRef as ReactComponent };